import React, { FC } from 'react'
import styled from 'styled-components'
import MenuSocialMedia from 'src/components/Common/SocialMendia'
import { Button } from 'src/components/Common/Button'
import Link from 'next/link'
import { ImExit } from 'react-icons/im'
import { FaMusic, FaUserAlt } from 'react-icons/fa'
import GroupButtonsComponent from 'src/components/Common/GroupButtons'
import { CategoriesApi, CategoriesWithArea } from 'src/service/api/api.types'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/store/rootReducers'
import { logout } from 'src/store/user'
import MenuSticky from 'src/components/Common/MenuSticky'
import { useIsIOSPlatform } from 'src/context/PlatformContext'
import { isIOS } from 'src/utils/platform'
import {
  Logo,
  LogoBackground,
  LogoWrapper,
  NovidadeIcon,
  NovidadeLink,
  NovidadesActions,
  NovidadesContent,
  NovidadesTitle,
  NovidadesTitleIcon,
  NovidadesWrapper,
} from './styles'
import { CategoryMenu } from '../Common/CategoryMenu'
import Container from '../Common/Container'

interface Props {
  showCategory?: boolean
  categories?: CategoriesApi
  customCategories?: Record<string, CategoriesWithArea>
  isIOSPlatform?: boolean
}

const HeaderWrapper = styled.header``

const Header: FC<Props> = props => {
  const { showCategory = true } = props
  const dispatch = useDispatch()
  const profile = useSelector((state: State) => state.user.profile)
  const isAuthenticated = useSelector((state: State) => state.user.isAuthenticated)
  const iosFromContext = useIsIOSPlatform()
  const isIOSPlatform = (props.isIOSPlatform ?? iosFromContext) || isIOS()
  const subscriptionUrl = 'https://www.cordasemusica.com.br/assinar'

  const handleIOSSubscribe = () => {
    if (typeof window === 'undefined') return

    const newWindow = window.open(subscriptionUrl, '_blank', 'noopener,noreferrer')

    if (!newWindow) {
      window.location.href = subscriptionUrl
    }
  }

  const buttonsLogger = () => {
    if (profile) {
      return (
        <div>
          <Button
            type="button"
            isLink
            href="/perfil"
            labelTx="header.Profile"
            preset="secondary"
            LeftAccessory={<FaUserAlt />}
          />
          <Button
            type="button"
            onClick={() => dispatch(logout())}
            labelTx="header.exit"
            preset="green"
            LeftAccessory={<ImExit />}
          />
        </div>
      )
    }
  }

  return (
    <HeaderWrapper>
      <MenuSticky />

      <Container className="padding-top">
        <LogoBackground>
          <nav className="nav">
            <MenuSocialMedia />
          </nav>

          <LogoWrapper>
            <Link legacyBehavior passHref href="/">
              <a>
                <Logo
                  src="https://res.cloudinary.com/cordasemusica/image/upload/v1678224794/logo_tk296u.gif"
                  alt="Logo Cordas e Música Projeto Musical"
                />
              </a>
            </Link>
          </LogoWrapper>

          <GroupButtonsComponent gridArea="group_button">
            {isAuthenticated === false ? (
              <>
                <Button
                  type="button"
                  isLink={!isIOSPlatform}
                  href={isIOSPlatform ? undefined : '/assinar'}
                  onClick={isIOSPlatform ? handleIOSSubscribe : undefined}
                  label={isIOSPlatform ? 'Planos no site' : undefined}
                  labelTx={isIOSPlatform ? undefined : 'header.register'}
                  preset="danger"
                  LeftAccessory={<FaMusic className="icon-login" />}
                />
                <Button
                  type="button"
                  isLink
                  href="/login"
                  labelTx="header.login"
                  preset="secondary"
                  LeftAccessory={<FaUserAlt />}
                />
              </>
            ) : (
              buttonsLogger()
            )}
          </GroupButtonsComponent>
        </LogoBackground>
      </Container>

      <NovidadesWrapper>
        <NovidadesContent>
          <NovidadesTitle>
            <NovidadesTitleIcon src="/icone-atencao.png" alt="Ícone de atenção" />
            Novidades
          </NovidadesTitle>

          <NovidadesActions>
            <NovidadeLink
              href="https://ferramentascordasemusica.com.br/afinador"
              target="_blank"
              rel="noopener noreferrer"
              $variant="blue"
            >
              <NovidadeIcon src="/icone-afinador.png" alt="Ícone de afinador" />
              Afinador
            </NovidadeLink>

            <NovidadeLink
              href="https://ferramentascordasemusica.com.br/metronomo"
              target="_blank"
              rel="noopener noreferrer"
              $variant="green"
            >
              <NovidadeIcon src="/icone-metronomo.jpg" alt="Ícone de metrônomo" />
              Metrônomo
            </NovidadeLink>
          </NovidadesActions>
        </NovidadesContent>
      </NovidadesWrapper>

      {showCategory && (
        <CategoryMenu categories={props.categories} customCategories={props.customCategories} />
      )}
    </HeaderWrapper>
  )
}

export default Header
